// extracted by mini-css-extract-plugin
export default {"option":"SwitchButton_option__jsJq2"};